import React, { useState, useEffect } from "react";
import { Box, Modal } from "@mui/material";
import {
  Navigation,
  HeroSection,
  AnalyticsShowcaseSection,
  ProblemSection,
  BenefitsSection,
  PricingComparison,
  TestimonialsSection,
  HowItWorksSection,
  FAQSection,
  Footer
} from '../components/landing';
import PricingSection from '../components/PricingSection';

const Landing = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Handle hash navigation on page load
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Small delay to ensure page is rendered
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  // Handle modal open/close
  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Navigation />

      {/* Main Content */}
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8f9fe 0%, #ffffff 100%)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          opacity: 0,
          animation: 'fadeIn 1s forwards',
          '@keyframes fadeIn': {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        }}
      >
        <HeroSection />
        <AnalyticsShowcaseSection />
        <ProblemSection />
        <BenefitsSection />
        <PricingComparison />
        <TestimonialsSection />
        <HowItWorksSection />

        {/* Pricing Section */}
        <Box id="pricing-section">
          <PricingSection />
        </Box>

        <FAQSection />

        {/* Enhanced Modal */}
        <Modal
          open={Boolean(selectedImage)}
          onClose={handleCloseModal}
          aria-labelledby="image-modal"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            backdropFilter: 'blur(8px)'
          }}
        >
          <Box
            sx={{
              position: 'relative',
              maxWidth: '95vw',
              maxHeight: '95vh',
              overflow: 'hidden',
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 24px 48px -12px rgba(0,0,0,0.3)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              '&:focus': {
                outline: 'none',
              },
              animation: 'modalFadeIn 0.3s ease-out',
              '@keyframes modalFadeIn': {
                from: {
                  opacity: 0,
                  transform: 'scale(0.95)'
                },
                to: {
                  opacity: 1,
                  transform: 'scale(1)'
                }
              }
            }}
            onClick={handleCloseModal}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Enlarged preview"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block'
                }}
              />
            )}
          </Box>
        </Modal>

        <Footer />
      </Box>
    </>
  );
};

export default Landing;
